import { Injectable, inject } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import {
    IRelatedProductsCallback,
    IRelatedProductsEngine,
    RelatedProductsService
} from '@df/catalog-ui/related-products/related-products.service';
import { ICategoryDataV2 } from '@df/catalog/category/category';
import { CategoryResource } from '@df/catalog/category/category.resource';
import { IProductDataV2 } from '@df/catalog/product/product';
import { ProductResource } from '@df/catalog/product/product.resource';
import { App } from '@df/core/app';
import flatten from 'lodash-es/flatten';
import shuffle from 'lodash-es/shuffle';
import take from 'lodash-es/take';
import uniq from 'lodash-es/uniq';

export interface ICategoryEngineOptions {
    // force category ids
    categoryIds?: number[];
}

@Injectable({
    providedIn: 'root'
})
export class CategoryEngine implements IRelatedProductsEngine {
    private productResource = inject(ProductResource);
    private app = inject(App);
    private requestService = inject(RequestService);

    get(sourceIds: number[], cb: IRelatedProductsCallback, options: ICategoryEngineOptions | undefined) {
        const categoryIds: number[] = (
            options?.categoryIds ||
            uniq(
                this.productResource
                    .getAllExisting(sourceIds)
                    .map(model => ((<IProductDataV2>model.data).categories ? (<IProductDataV2>model.data!).categories?.last : undefined))
                    .filter(item => !!item) as number[]
            )
        ).filter(Boolean);

        if (Array.isArray(categoryIds) && categoryIds.length && this.app.isPlatformBrowser) {
            this.requestService
                .loadCategoryProducts({
                    verbosity: 2,
                    limit: 50,
                    category: categoryIds[0]
                })
                .then(products => {
                    cb(shuffle(products.map(product => product.id)));
                })
                .catch(() => {
                    cb([]);
                });
        } else {
            cb([]);
        }
    }
}

RelatedProductsService.registerEngine('category', CategoryEngine);
